export default "__VITE_ASSET__d6faea0b__"